@if (authService.loggedIn && authService.isCompanyChosen) {
  <div class="search-bar w-100 mb-m">
    @if (showSearch) {
      <div class="search-bar-container user-select-none">
        <form novalidate [formGroup]="rdgform">
          <input
            name="searchboxterm"
            id="searchboxterm"
            class="form-control header-search-input search-expand-cus"
            formControlName="searchTerm"
            autocomplete="off"
            [placeholder]="'$message_searchplaceholder$' | translate"
            (click)="clickSearchBox()"
            (keyup)="keyup($event)" />
        </form>
        <div class="search-trigger">
          <label for="search">
            <i class="material-icons mi-inline">search</i>
          </label>
        </div>
        @if (showSearchPopup) {
          <div class="search-clear" (click)="closeSearch()">
            <i class="material-icons mi-inline">close</i>
          </div>
        }
      </div>
    }
    @if (showSearchPopup) {
      <div class="search-result-container">
        @if (customers.length === 0 && bookingAgents.length === 0 && accounts.length === 0 && !searching) {
          <div class="h-100 d-flex justify-content-end align-items-center gap-2 p-2">
            <app-country-select
              size="slim"
              [ngClass]="'h-100 d-flex justify-content-center align-items-center'"
              [showClear]="true"
              [(countryCode)]="selectedCountryCode"
              (countryCodeChange)="onCountryCodeChange()" />

            <app-search-bar-active-toggle [active]="onlyActiveCustomers" (toggled)="toggleOnlyActiveCustomers()" />
          </div>
        }
        @if (isCustomerExist === 1 || isBookingAgentExist === 1 || isAccountExist === 1) {
          <div class="d-flex align-items-stretch w-100 no-gutters">
            @if (customers.length === 0 && bookingAgents.length === 0 && accounts.length === 0 && !searching) {
              <div class="w-100 justify-content-center">
                <div class="col-auto py-5 mb-3">
                  <div class="no-results text-center">
                    @if (searchTerm?.length > 1) {
                      <h4 class="text-dark-blue">{{ '$message_noresultsfound$' | translate }}</h4>
                    }
                    @if (searchInfo === 't' && searchTerm?.length > 1) {
                      <div class="mb-1">
                        <span
                          >{{ '$message_noresultsletters1$' | translate }} <strong>{{ searchTerm }}</strong
                          >. </span
                        ><span>{{ '$message_noresultsletters2$' | translate }}</span>
                      </div>
                    }
                    @if (searchInfo === 'n' && searchTerm?.length > 1) {
                      <div class="mb-1">
                        <span
                          >{{ '$message_noresultsnumbers$' | translate }} <strong>{{ searchTerm }}</strong
                          >. </span
                        ><span>{{ '$message_noresultsletters2$' | translate }}</span>
                      </div>
                    }
                    @if (searchInfo === 'm' && searchTerm?.length > 1) {
                      <div class="mb-1">
                        <span
                          >{{ '$message_noresultsmixed$' | translate }} <strong>{{ searchTerm }}</strong
                          >. </span
                        ><span>{{ '$message_noresultsletters2$' | translate }}</span>
                      </div>
                    }
                    @if (searchTerm?.length < 2) {
                      <div>
                        <h4 class="text-dark-blue">{{ '$message_searchbarclick_withcustomers_title$' | translate }}</h4>
                        <p class="mb-5">{{ '$message_searchbarclick_withcustomers_sub1$' | translate }}</p>
                        <p class="m-0">
                          <strong>{{ '$message_searchbarclick_withcustomers_sub2$' | translate }}</strong>
                        </p>
                        <p class="m-0">{{ '$message_searchbarclick_withcustomerspartners_sub3$' | translate }}</p>
                      </div>
                    }
                  </div>
                  @if (searchTerm?.length > 1) {
                    <app-search-bar-get-started />
                  }
                </div>
              </div>
            }
          </div>
        }
        @if (isBookingAgentExist === 0 && isCustomerExist === 0 && isAccountExist === 0 && !searching) {
          <div class="d-flex align-items-stretch w-100 no-gutters">
            <div class="w-100 justify-content-center">
              <div class="col-auto py-5 mb-3">
                <div class="no-results text-center">
                  <h4 class="text-dark-blue">{{ '$message_emptydbcustomerpartner_title$' | translate }}</h4>
                  <p class="mb-0">{{ '$message_emptydbcustomerpartner_sub$' | translate }}</p>
                </div>
                @if (searchTerm?.length > 1) {
                  <app-search-bar-get-started />
                }
              </div>
            </div>
          </div>
        }
        @if (searching) {
          <div class="d-flex align-items-stretch w-100 no-gutters">
            <div class="w-100 justify-content-center">
              <div class="col-auto">
                <div class="py-5 no-results text-center">
                  <h4 class="text-dark-blue">
                    <strong>{{ '$searchbar_message_searching$' | translate }}</strong
                    >&nbsp;<strong>{{ searchTerm }}</strong
                    >...
                  </h4>
                </div>
              </div>
            </div>
          </div>
        }
        @if ((customers.length > 0 || bookingAgents.length > 0 || accounts.length > 0) && !searching) {
          <div class="bg-gray-100 pt-2 row no-gutters">
            <div class="card-nav col-md-10 col-lg-9 col-xl-8 px-0">
              <ul class="d-block nav nav-tabs d-flex" role="tablist">
                <li class="d-inline-block col-md-4 cal-sm-4 text-center bg-white border-right p-0" role="presentation">
                  <a
                    appKeyboardClickable
                    role="tab"
                    class="text-black lh-50px h-50px cursor-pointer"
                    [attr.aria-selected]="activetab === 'customers'"
                    [ngClass]="activetab === 'customers' ? 'active show' : ''"
                    (click)="activetab = 'customers'">
                    <span>
                      {{ '$label_customers$' | translate }}
                      ({{ customers.length }})
                    </span>
                  </a>
                </li>
                <li class="d-inline-block col-md-4 cal-sm-4 text-center bg-white border-right p-0" role="presentation">
                  <a
                    appKeyboardClickable
                    role="tab"
                    class="text-black lh-50px h-50px cursor-pointer"
                    [attr.aria-selected]="activetab === 'bookingagents'"
                    [ngClass]="activetab === 'bookingagents' ? 'active show' : ''"
                    (click)="activetab = 'bookingagents'">
                    <span>
                      {{ '$label_partners$' | translate }}
                      ({{ bookingAgents.length }})
                    </span>
                  </a>
                </li>
                <li class="d-inline-block col-md-4 cal-sm-4 text-center bg-white p-0" role="presentation">
                  <a
                    appKeyboardClickable
                    role="tab"
                    class="text-black lh-50px h-50px cursor-pointer"
                    [attr.aria-selected]="activetab === 'accounts'"
                    [ngClass]="activetab === 'accounts' ? 'active show' : ''"
                    (click)="activetab = 'accounts'">
                    <span>
                      {{ '$label_accounts$' | translate }}
                      ({{ accounts.length }})
                    </span>
                  </a>
                </li>
              </ul>
            </div>
            @if (activetab === 'bookingagents' || activetab === 'accounts') {
              <div class="col-md-1 col-lg-2 col-xl-2">
                <div class="h-100 px-2">
                  <app-country-select
                    size="slim"
                    [ngClass]="'h-100 d-flex justify-content-center align-items-center'"
                    [showClear]="true"
                    [(countryCode)]="selectedCountryCode"
                    (countryCodeChange)="onCountryCodeChange()" />
                </div>
              </div>
            }
            <div class="col-md-1 col-lg-1 col-xl-2">
              <app-search-bar-active-toggle [active]="onlyActiveCustomers" (toggled)="toggleOnlyActiveCustomers()" />
            </div>
          </div>

          <div class="row align-items-stretch no-gutters">
            <div class="search-result-lists user-select-none d-flex flex-column col-12 col-sm5 col-md-3">
              <div class="tab-content">
                <div
                  class="card-body tab-pane p-0"
                  id="customers"
                  [ngClass]="activetab === 'customers' ? 'active' : ''">
                  @if (customers?.length > 0) {
                    <div class="search-result-lists-wrap scrolling-results">
                      <ul class="pb-52">
                        @for (customer of customers; track customer.id) {
                          <li
                            class="search-result-item"
                            [class.active]="customer === selectedCustomer"
                            (click)="viewCustomer(customer)"
                            (mouseenter)="onCustomerMouseEnter(customer)"
                            (mouseleave)="onCustomerMouseLeave()">
                            <span class="search-result-item-wrap clearfix">
                              <div class="row no-gutters align-items-center flex-nowrap">
                                <div class="col-auto">
                                  <div class="avatar avatar-sm avatar-yellow">
                                    <span>{{ customer.name | initials }}</span>
                                  </div>
                                </div>
                                <div class="col">
                                  <span class="search-result-meta">
                                    <strong>{{ customer.name }}</strong>
                                    <small>{{ customer.email }}</small>
                                  </span>
                                </div>
                              </div>
                            </span>
                          </li>
                        }
                      </ul>
                    </div>
                  } @else {
                    <div class="text-center scrolling-results w-100 pt-3 px-2">
                      <h4 class="text-dark-blue">
                        {{ '$search_nocustomersyet$' | translate }}
                      </h4>
                      <span>{{ '$search_nocustomer_message$' | translate }}</span>
                    </div>
                  }
                  <div class="d-flex justify-content-center py-3 px-4">
                    @if (authService.hasMultipleCreateFlow) {
                      <button
                        class="btn btn-primary btn-capsule d-flex py-0 pl-4"
                        [routerLink]="`/${authService.companyUrl}/create/choose/customer`"
                        [permission]="globals.PERMISSION_ASSIGNMENT_CREATE">
                        <span class="pr-2">{{ '$button_create_customer$' | translate }}</span
                        ><i class="material-icons mi-inline">person</i>
                      </button>
                    }
                    @if (!authService.hasMultipleCreateFlow) {
                      <button
                        class="btn btn-primary btn-capsule d-flex py-0 pl-4"
                        [routerLink]="`/${authService.companyUrl}/create/move/customer`"
                        [permission]="globals.PERMISSION_ASSIGNMENT_CREATE">
                        <span class="pr-2">{{ '$button_create_customer$' | translate }}</span
                        ><i class="material-icons mi-inline">person</i>
                      </button>
                    }
                  </div>
                </div>
                <div
                  class="card-body tab-pane p-0"
                  id="bookingagents"
                  [ngClass]="activetab === 'bookingagents' ? 'active' : ''">
                  @if (bookingAgents?.length > 0) {
                    <div class="search-result-lists-wrap scrolling-results">
                      <ul class="pb-52">
                        @for (bookingAgent of bookingAgents; track bookingAgent.id) {
                          <li
                            class="search-result-item"
                            [class.active]="bookingAgent === selectedBookingAgent"
                            (click)="viewBookingAgent(bookingAgent)"
                            (mouseenter)="onBookingAgentMouseEnter(bookingAgent)"
                            (mouseleave)="onBookingAgentMouseLeave()">
                            <span class="search-result-item-wrap clearfix">
                              <div class="row no-gutters align-items-center flex-nowrap">
                                <div class="col-auto">
                                  <div class="search-result-thumbnail bg-blue">
                                    {{ bookingAgent?.name[0] }}{{ bookingAgent?.name[1] }}
                                  </div>
                                </div>
                                <div class="col">
                                  <span class="search-result-meta">
                                    <strong>{{ bookingAgent.name }}</strong>
                                    <small>{{ bookingAgent.city }}</small>
                                  </span>
                                </div>
                              </div>
                            </span>
                          </li>
                        }
                      </ul>
                    </div>
                  } @else {
                    <div class="text-center scrolling-results w-100 pt-3 px-2">
                      <h4 class="text-dark-blue">
                        {{ '$search_nopartnersyet$' | translate }}
                      </h4>
                      <span>{{ '$search_nopartner_message$' | translate }}</span>
                    </div>
                  }
                  <div class="d-flex justify-content-center my-3 mx-4">
                    @if (authService.hasMultipleCreateFlow) {
                      <button
                        class="btn btn-primary btn-capsule d-flex py-0 pl-4"
                        [routerLink]="`/${authService.companyUrl}/create/choose/agent`"
                        [permission]="globals.PERMISSION_ASSIGNMENT_CREATE">
                        <span class="pr-2">{{ '$button_create_new_partner$' | translate }}</span
                        ><i class="material-icons mi-inline">business</i>
                      </button>
                    } @else {
                      <button
                        class="btn btn-primary btn-capsule d-flex py-0 pl-4"
                        [routerLink]="`/${authService.companyUrl}/create/move/agent`"
                        [permission]="globals.PERMISSION_ASSIGNMENT_CREATE">
                        <span class="pr-2">{{ '$button_create_new_partner$' | translate }}</span
                        ><i class="material-icons mi-inline">business</i>
                      </button>
                    }
                  </div>
                </div>
                <div class="card-body tab-pane p-0" id="accounts" [ngClass]="activetab === 'accounts' ? 'active' : ''">
                  @if (accounts?.length > 0) {
                    <div class="search-result-lists-wrap scrolling-results">
                      <ul class="pb-52">
                        @for (account of accounts; track account.id) {
                          <li
                            class="search-result-item"
                            [class.active]="account === selectedAccount"
                            (click)="viewAccount(account)"
                            (mouseenter)="onAccountMouseEnter(account)"
                            (mouseleave)="onAccountMouseLeave()">
                            <span class="search-result-item-wrap clearfix">
                              <div class="row no-gutters align-items-center flex-nowrap">
                                <div class="col-auto">
                                  <div class="search-result-thumbnail bg-lavender">
                                    {{ account?.name[0] }}{{ account?.name[1] }}
                                  </div>
                                </div>
                                <div class="col">
                                  <span class="search-result-meta">
                                    <strong>{{ account.name }}</strong>
                                    <small>{{ account.city }}</small>
                                  </span>
                                </div>
                              </div>
                            </span>
                          </li>
                        }
                      </ul>
                    </div>
                  } @else {
                    <div class="text-center scrolling-results w-100 pt-3 px-2">
                      <h4 class="text-dark-blue">
                        {{ '$search_noaccountsyet$' | translate }}
                      </h4>
                      <span>{{ '$search_noaccount_message$' | translate }}</span>
                    </div>
                  }
                  <div class="d-flex justify-content-center my-3 mx-4">
                    @if (authService.hasMultipleCreateFlow) {
                      <button
                        class="btn btn-primary btn-capsule d-flex py-0 pl-4"
                        [routerLink]="`/${authService.companyUrl}/create/choose/account`"
                        [permission]="globals.PERMISSION_ASSIGNMENT_CREATE">
                        <span class="pr-2">{{ '$button_create_new_account$' | translate }}</span
                        ><i class="material-icons mi-inline">account_box</i>
                      </button>
                    }
                    @if (!authService.hasMultipleCreateFlow) {
                      <button
                        class="btn btn-primary btn-capsule d-flex py-0 pl-4"
                        [routerLink]="`/${authService.companyUrl}/create/move/account`"
                        [permission]="globals.PERMISSION_ASSIGNMENT_CREATE">
                        <span class="pr-2">{{ '$button_create_new_account$' | translate }}</span
                        ><i class="material-icons mi-inline">account_box</i>
                      </button>
                    }
                  </div>
                </div>
              </div>
            </div>
            @if (activetab === 'customers') {
              <div
                class="card search-result-preview px-0 pb-0 col-12 col-sm-7 col-md-9 search-result-preview-customers"
                [ngClass]="customers?.length === 0 ? 'text-center' : ''">
                @if (selectedCustomer) {
                  <a class="card-header py-4" (click)="viewCustomer(selectedCustomer)">
                    <div class="search-result-preview-head row clearfix">
                      <div class="col-12 col-xl-3 text-center overflow-hidden">
                        <div class="avatar avatar-lg avatar-yellow">
                          <span>{{ selectedCustomer.name | initials }}</span>
                        </div>
                      </div>
                      <div class="col-12 col-xl-9">
                        <div class="search-result-preview-meta">
                          <div class="row customer-meta">
                            <div class="d-none d-xl-flex col-12">
                              <h4 class="m-0 align-self-center">
                                {{ selectedCustomer.name }} ({{ selectedCustomer.friendlyNumber }})
                              </h4>
                            </div>
                            <div class="col-12 col-xl-6">
                              <dl class="customer-meta-details">
                                <div class="row no-gutters">
                                  <div class="col-6 col-xl-12">
                                    <label class="m-0">{{ '$field_email$' | translate }}</label>
                                  </div>
                                  <div class="col-6 col-xl-12">
                                    <span>{{ selectedCustomer.email || ('$not_available$' | translate) }}</span>
                                  </div>
                                </div>
                              </dl>
                            </div>
                            <div class="col-12 col-xl-6">
                              <dl class="customer-meta-details">
                                <div class="row no-gutters">
                                  <div class="col-6 col-xl-12">
                                    <label class="m-0">{{ '$phone$' | translate }}</label>
                                  </div>
                                  <div class="col-6 col-xl-12">
                                    <span>{{ selectedCustomer.phone || ('$not_available$' | translate) }}</span>
                                  </div>
                                </div>
                              </dl>
                            </div>
                            <div class="col-12 col-xl-6">
                              <dl class="customer-meta-details">
                                <div class="row no-gutters">
                                  <div class="col-6 col-xl-12">
                                    <label class="m-0">{{ '$city$' | translate }}</label>
                                  </div>
                                  <div class="col-6 col-xl-12">
                                    @if (selectedCustomer.city || selectedCustomer.countryCode) {
                                      <app-country-name
                                        displayMode="flagAndCity"
                                        [city]="selectedCustomer.city"
                                        [countryCode]="selectedCustomer.countryCode" />
                                    } @else {
                                      {{ '$not_available$' | translate }}
                                    }
                                  </div>
                                </div>
                              </dl>
                            </div>
                            <div class="col-12 col-xl-6">
                              <dl class="customer-meta-details">
                                <div class="row no-gutters">
                                  <div class="col-6 col-xl-12">
                                    <label class="m-0">{{ '$address$' | translate }}</label>
                                  </div>
                                  <div class="col-6 col-xl-12">
                                    <span>{{ selectedCustomer.address || ('$not_available$' | translate) }}</span>
                                  </div>
                                </div>
                              </dl>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                  <app-assignment-list
                    [activeOnly]="onlyActiveCustomers"
                    [customerId]="selectedCustomer.id"
                    [bookingAgentId]="null"
                    [accountId]="null"
                    [assignments]="customerAssignments"
                    [title]=""
                    (assignmentClosedEvent)="onCustomerAssignmentClosed()" />
                }
              </div>
            }
            @if (activetab === 'bookingagents') {
              <div
                class="card search-result-preview px-0 pb-0 col-12 col-sm-7 col-md-9 search-result-preview-booking-agents"
                [ngClass]="bookingAgents?.length === 0 ? 'text-center' : ''">
                @if (selectedBookingAgent) {
                  <a class="card-header py-4" (click)="viewBookingAgent(selectedBookingAgent)">
                    <div class="search-result-preview-head clearfix row">
                      <div
                        class="col-12 col-xl-3 text-center overflow-hidden"
                        (click)="viewBookingAgent(selectedBookingAgent)">
                        <div class="avatar avatar-lg avatar-blue">
                          <span> {{ selectedBookingAgent.name | initials }}</span>
                        </div>
                      </div>
                      <div class="col-12 col-xl-9">
                        <div class="search-result-preview-meta">
                          <div class="row customer-meta">
                            <div class="d-none d-xl-flex col-9">
                              <h4 class="m-0 align-self-center">
                                {{ selectedBookingAgent.name }} ({{ selectedBookingAgent.friendlyNumber }})
                              </h4>
                              <div class="ml-1">
                                @if (selectedBookingAgent.isBlocked) {
                                  <app-pill icon="block" color="red" [slim]="true" [label]="'$blocked$' | translate" />
                                }
                              </div>
                            </div>
                            <div
                              class="d-none d-xl-flex col-3"
                              (click)="openRolodexNoteView($event, rolodexNoteViewDialog, selectedBookingAgent.id)">
                              <a class="btn-link d-block">{{ '$notes$' | translate }}</a>
                            </div>
                            <div class="col-12 col-xl-6">
                              <dl class="customer-meta-details">
                                <div class="row no-gutters">
                                  <div class="col-6 col-xl-12">
                                    <label class="m-0">{{ '$field_email$' | translate }}</label>
                                  </div>
                                  <div class="col-6 col-xl-12">
                                    <span>{{ selectedBookingAgent.email || ('$not_available$' | translate) }}</span>
                                  </div>
                                </div>
                              </dl>
                            </div>
                            <div class="col-12 col-xl-6">
                              <dl class="customer-meta-details">
                                <div class="row no-gutters">
                                  <div class="col-6 col-xl-12">
                                    <label class="m-0">{{ '$field_phone$' | translate }}</label>
                                  </div>
                                  <div class="col-6 col-xl-12">
                                    <span>{{ selectedBookingAgent.phone || ('$not_available$' | translate) }}</span>
                                  </div>
                                </div>
                              </dl>
                            </div>
                            <div class="col-12 col-xl-6">
                              <dl class="customer-meta-details">
                                <div class="row no-gutters">
                                  <div class="col-6 col-xl-12">
                                    <label class="m-0">{{ '$city$' | translate }}</label>
                                  </div>
                                  <div class="col-6 col-xl-12">
                                    @if (selectedBookingAgent.city || selectedBookingAgent.countryCode) {
                                      <app-country-name
                                        displayMode="flagAndCity"
                                        [city]="selectedBookingAgent.city"
                                        [countryCode]="selectedBookingAgent.countryCode" />
                                    } @else {
                                      {{ '$not_available$' | translate }}
                                    }
                                  </div>
                                </div>
                              </dl>
                            </div>
                            <div class="col-12 col-xl-6">
                              <dl class="customer-meta-details">
                                <div class="row no-gutters">
                                  <div class="col-6 col-xl-12">
                                    <label class="m-0">{{ '$address$' | translate }}</label>
                                  </div>
                                  <div class="col-6 col-xl-12">
                                    <span>{{ selectedBookingAgent.address || ('$not_available$' | translate) }}</span>
                                  </div>
                                </div>
                              </dl>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                  <app-assignment-list
                    [customerId]="null"
                    [bookingAgentId]="selectedBookingAgent.id"
                    [accountId]="null"
                    [showCreateButton]="!selectedBookingAgent.isBlocked"
                    [assignments]="bookingAgentAssignments"
                    [title]=""
                    [activeOnly]="onlyActiveCustomers"
                    (assignmentClosedEvent)="onAgentAssignmentClosed()" />
                }
              </div>
            }
            @if (activetab === 'accounts') {
              <div
                class="card search-result-preview px-0 pb-0 col-12 col-sm-7 col-md-9 search-result-preview-accounts"
                [ngClass]="accounts?.length === 0 ? 'text-center' : ''">
                @if (selectedAccount) {
                  <a class="card-header py-4" (click)="viewAccount(selectedAccount)">
                    <div class="search-result-preview-head clearfix row">
                      <div class="col-12 col-xl-3 text-center overflow-hidden">
                        <div class="avatar avatar-lg avatar-lavender">
                          <span> {{ selectedAccount.name | initials }}</span>
                        </div>
                      </div>
                      <div class="col-12 col-xl-9">
                        <div class="search-result-preview-meta">
                          <div class="row customer-meta">
                            <div class="d-none d-xl-flex col-9">
                              <h4 class="m-0 align-self-center">
                                {{ selectedAccount.name }} ({{ selectedAccount.friendlyNumber }})
                              </h4>
                              <div class="ml-1">
                                @if (selectedAccount.isBlocked) {
                                  <app-pill icon="block" color="red" [slim]="true" [label]="'$blocked$' | translate" />
                                }
                              </div>
                            </div>
                            <div
                              class="d-none d-xl-flex col-3"
                              (click)="openRolodexNoteView($event, rolodexNoteViewDialog, selectedAccount.id)">
                              <a class="btn-link d-block">{{ '$notes$' | translate }}</a>
                            </div>
                            <div class="col-12 col-xl-6">
                              <dl class="customer-meta-details">
                                <div class="row no-gutters">
                                  <div class="col-6 col-xl-12">
                                    <label class="m-0">{{ '$field_email$' | translate }}</label>
                                  </div>
                                  <div class="col-6 col-xl-12">
                                    <span>{{ selectedAccount.email || ('$not_available$' | translate) }}</span>
                                  </div>
                                </div>
                              </dl>
                            </div>
                            <div class="col-12 col-xl-6">
                              <dl class="customer-meta-details">
                                <div class="row no-gutters">
                                  <div class="col-6 col-xl-12">
                                    <label class="m-0">{{ '$field_phone$' | translate }}</label>
                                  </div>
                                  <div class="col-6 col-xl-12">
                                    <span>{{ selectedAccount.phone || ('$not_available$' | translate) }}</span>
                                  </div>
                                </div>
                              </dl>
                            </div>
                            <div class="col-12 col-xl-6">
                              <dl class="customer-meta-details">
                                <div class="row no-gutters">
                                  <div class="col-6 col-xl-12">
                                    <label class="m-0">{{ '$city$' | translate }}</label>
                                  </div>
                                  <div class="col-6 col-xl-12">
                                    @if (selectedAccount.city || selectedAccount.countryCode) {
                                      <app-country-name
                                        displayMode="flagAndCity"
                                        [city]="selectedAccount.city"
                                        [countryCode]="selectedAccount.countryCode" />
                                    } @else {
                                      {{ '$not_available$' | translate }}
                                    }
                                  </div>
                                </div>
                              </dl>
                            </div>
                            <div class="col-12 col-xl-6">
                              <dl class="customer-meta-details">
                                <div class="row no-gutters">
                                  <div class="col-6 col-xl-12">
                                    <label class="m-0">{{ '$address$' | translate }}</label>
                                  </div>
                                  <div class="col-6 col-xl-12">
                                    <span>{{ selectedAccount.address || ('$not_available$' | translate) }}</span>
                                  </div>
                                </div>
                              </dl>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                  <app-assignment-list
                    [customerId]="null"
                    [bookingAgentId]="null"
                    [accountId]="selectedAccount.id"
                    [showCreateButton]="!selectedAccount.isBlocked"
                    [assignments]="accountAssignments"
                    [title]=""
                    [activeOnly]="onlyActiveCustomers"
                    (assignmentClosedEvent)="onAccountAssignmentClosed()" />
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
}

<ng-template #rolodexNoteViewDialog let-modal>
  <app-rolodex-note-view-dialog [modal]="modal" [rolodexCompanyId]="selectedRolodexCompanyId" />
</ng-template>
